const faqs = [
  {
    q: '51吃瓜黑料是什么平台？',
    a: '51吃瓜黑料是一个专注娱乐八卦与黑料爆料的在线视频聚合平台，提供全网最新最热的吃瓜视频、黑料爆料视频在线观看服务。平台每日更新海量51吃瓜黑料视频，涵盖明星网红、综艺内幕、圈内秘闻等多个维度，是目前国内最大的吃瓜视频社区之一。',
  },
  {
    q: '51吃瓜黑料视频需要付费观看吗？',
    a: '不需要。51吃瓜黑料平台上所有吃瓜视频和黑料爆料视频均免费在线观看，无需注册、无需付费、无需下载。直接打开网页即可畅享最新最热的黑料视频内容，真正做到让吃瓜零门槛。',
  },
  {
    q: '平台上的爆料内容可靠吗？',
    a: '51吃瓜黑料对内容实行严格审核机制，所有上架的黑料视频均经过多源交叉验证。我们坚持"有图有真相、有视频有实锤"的原则，对于未经证实的传闻会有明确标注，确保吃瓜群众获取的信息真实可靠、不传谣不信谣。',
  },
  {
    q: '如何向51吃瓜黑料投稿爆料？',
    a: '如果你手上掌握独家爆料线索或51吃瓜黑料视频素材，可以通过平台投稿邮箱 tips@51chigua.com 联系我们。所有投稿严格保密，爆料人信息绝不外泄。优质爆料一经采纳，将按稿件质量支付相应稿酬。',
  },
  {
    q: '51吃瓜黑料视频在手机上能看吗？',
    a: '可以。51吃瓜黑料平台全面适配手机端和电脑端，无论是安卓还是苹果设备，打开浏览器即可流畅观看所有51吃瓜视频和黑料爆料视频。移动端同样享受免费、高清、流畅的观看体验，随时随地吃瓜不耽误。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            关于51吃瓜黑料平台的常见疑问解答
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => (
              <details
                key={i}
                className="group rounded-xl bg-background-50 border border-background-200/50 overflow-hidden"
                open={i === 0}
              >
                <summary className="flex items-center justify-between p-5 md:p-6 cursor-pointer list-none">
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 pr-4">
                    {faq.q}
                  </h3>
                  <div className="flex-shrink-0 w-7 h-7 rounded-full bg-background-100 flex items-center justify-center group-open:bg-primary-100 transition-colors duration-200">
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-500 group-open:rotate-180 transition-all duration-200"></i>
                  </div>
                </summary>
                <div className="px-5 md:px-6 pb-5 md:pb-6 -mt-1">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}